createComponent('ProductEstimatedDelivery', () => {
  return {
    __cache: {},
    shouldDisplayTooltipMessage: false,
    cache(key = '', value = null, dependencies = null) {
      if (
        !this.__cache[key] ||
        !Shopify.isDeepEqual(dependencies, this.__cache[key].dependencies)
      ) {
        this.__cache[key] = {
          value: typeof value === 'function' ? value() : value,
          dependencies: Shopify.cloneDeep(dependencies),
        }
      }

      return this.__cache[key].value
    },
    get deliveryRange() {
      return this.cache(
        'deliveryRange',
        () => {
          const { minDays, maxDays, maxDaysVendor, maxDaysCarrier, items } =
            this.product.allVariants.reduce(
              (data, { shippingTimeline, ...variant }) => {
                if (!shippingTimeline || !shippingTimeline.timeline) return data

                const item = {
                  ...{},
                  ...variant,
                  ...shippingTimeline,
                  timeline: {
                    ...{},
                    ...shippingTimeline.timeline,
                    min: parseInt(shippingTimeline?.timeline?.min ?? 0),
                    max: parseInt(shippingTimeline?.timeline?.max ?? 0),
                  },
                  weight: Number(shippingTimeline.weight),
                  quantity: this.product.quantity,
                }

                return {
                  minDays: Math.max(item.timeline.min, data.minDays),
                  maxDays: Math.max(item.timeline.max, data.maxDays),
                  maxDaysVendor:
                    item.timeline.max > data.maxDays
                      ? item.vendor
                      : data.maxDaysVendor,
                  maxDaysCarrier:
                    item.timeline.max > data.maxDays
                      ? item.timeline.carrier
                      : data.maxDaysCarrier,
                  items: [...data.items, item],
                }
              },
              {
                minDays: 0,
                maxDays: 0,
                maxDaysVendor: '',
                maxDaysCarrier: '',
                items: [],
              }
            )

          return !items.length
            ? null
            : ShippingTimelineCalculator.estimate(
                items,
                Math.min(minDays),
                Math.max(maxDays),
                maxDaysVendor,
                maxDaysCarrier,
                true
              )
        },
        {
          shippingTimelines: this.product.allVariants.map(
            (v) => v.shippingTimeline
          ),
        }
      )
    },
    toggleDisplayMessage() {
      this.shouldDisplayTooltipMessage = !this.shouldDisplayTooltipMessage
    },
    forceCloseMessage() {
      this.shouldDisplayTooltipMessage = false
    },
  }
})
